// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"AdAlert_adContainer__3qEtq","adImg":"AdAlert_adImg__MvhsL","closeBtn":"AdAlert_closeBtn__XPIbF"};